import { Drawer } from 'ant-design-vue';

export default {
    components: {
        Drawer,
    },
    data: () => ({
        visible: false,
    }),
    methods: {
        show() {
            this.visible = true;

            this.$emit('show');
        },
        close() {
            this.visible = false;

            this.$emit('close');
        },
    },
};